/* global _api */
import React, { Component } from "react";
import Card from "../../../../components/Card/Card.jsx";
import Button from "../../../../components/CustomButton/CustomButton.jsx";
import {
    Grid,
    Row,
    Col,
    FormGroup,
    FormControl,
    ControlLabel
} from "react-bootstrap";

const API_ERROR_MESSAGES = {
    "E_IKEA_PRICING_FILE_REQUIRED": "Wybierz plik CSV do importu.",
    "E_IKEA_PRICING_FILE_INVALID": "Wybrany plik jest nieprawidłowy. Wgraj poprawny plik CSV.",
    "E_IKEA_PRICING_COLUMNS_INVALID": "Plik ma nieprawidłowe kolumny. Użyj aktualnego szablonu IKEA Pricing.",
    "E_IKEA_PRICING_FILE_EMPTY": "Plik nie zawiera danych do importu.",
    "E_IKEA_PRICING_PARSE_FAILED": "Nie udało się odczytać pliku. Zweryfikuj format i spróbuj ponownie.",
    "E_IKEA_PRICING_IMPORT_FAILED": "Import nie powiódł się. Spróbuj ponownie lub skontaktuj się z zespołem technicznym."
};

class ExpertAdminImportIkeaPricing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            fileInputKey: 0,
            versionLabel: "",
            uploading: false,
            successMessage: "",
            errorMessage: ""
        };
    }

    componentWillUnmount() {
        _api.abort();
    }

    getErrorMessage = (errorCode) => {
        if (!errorCode) {
            return "Wystąpił błąd podczas importu cennika IKEA.";
        }
        return API_ERROR_MESSAGES[errorCode] || `Wystąpił błąd importu (${errorCode}).`;
    }

    normalizeErrorCode = (error) => {
        if (!error) {
            return null;
        }
        if (typeof error === "number") {
            return `HTTP_${error}`;
        }
        if (typeof error === "string") {
            return error;
        }
        if (typeof error.status === "number") {
            return `HTTP_${error.status}`;
        }
        if (typeof error.status?.code === "number") {
            return `HTTP_${error.status.code}`;
        }
        if (typeof error.data === "string") {
            return error.data;
        }
        if (typeof error.code === "string") {
            return error.code;
        }
        if (typeof error.message === "string") {
            return error.message;
        }
        return null;
    }

    handleVersionLabelChange = (event) => {
        this.setState({
            versionLabel: event.target.value,
            successMessage: "",
            errorMessage: ""
        });
    }

    handleFileChange = (event) => {
        const file = event.target.files && event.target.files.length ? event.target.files[0] : null;
        this.setState({
            selectedFile: file,
            successMessage: "",
            errorMessage: ""
        });
    }

    validateBeforeUpload = () => {
        const { selectedFile } = this.state;
        if (!selectedFile) {
            return "Wybierz plik CSV do importu.";
        }

        const fileName = (selectedFile.name || "").toLowerCase();
        if (!(fileName.endsWith(".csv"))) {
            return "Dozwolone są tylko pliki csv.";
        }
        return "";
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.uploading) {
            return;
        }

        const validationError = this.validateBeforeUpload();
        if (validationError) {
            this.setState({ errorMessage: validationError, successMessage: "" });
            this.props.showNoty("tr", "error", validationError);
            return;
        }

        const { selectedFile, versionLabel } = this.state;
        this.setState({ uploading: true, successMessage: "", errorMessage: "" });
        this.props.showNoty("tr", "info", "Wgrywanie cennika IKEA...");
        const payload = {
            file: [selectedFile],
            files: [selectedFile]
        };
        if (versionLabel.trim()) {
            payload.versionLabel = versionLabel.trim();
        }

        _api.request(
            "/admin/import/ikea-pricing",
            payload,
            () => {
                const successMessage = "Cennik IKEA został poprawnie zaimportowany.";
                this.setState((prevState) => ({
                    uploading: false,
                    selectedFile: null,
                    fileInputKey: prevState.fileInputKey + 1,
                    versionLabel: "",
                    successMessage: successMessage,
                    errorMessage: ""
                }));
                this.props.showNoty("tr", "success", successMessage);
            },
            (error) => {
                const errorCode = this.normalizeErrorCode(error);
                const errorMessage = this.getErrorMessage(errorCode);
                this.setState({
                    uploading: false,
                    successMessage: "",
                    errorMessage: errorMessage
                });
                this.props.showNoty("tr", "error", errorMessage);
            },
            (progress) => {
                this.props.setProgress(progress);
            }
        );
    }

    renderStatus() {
        if (this.state.successMessage) {
            return (
                <div className="alert alert-success" style={{ marginTop: "12px", marginBottom: "0" }}>
                    {this.state.successMessage}
                </div>
            );
        }
        if (this.state.errorMessage) {
            return (
                <div className="alert alert-danger" style={{ marginTop: "12px", marginBottom: "0" }}>
                    {this.state.errorMessage}
                </div>
            );
        }
        return null;
    }

    render() {
        const { selectedFile, fileInputKey, versionLabel, uploading } = this.state;

        return (
            <div className="main-content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                title="IKEA Import"
                                content={
                                    <form onSubmit={this.handleSubmit}>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <ControlLabel>Plik CSV</ControlLabel>
                                                    <FormControl
                                                        key={fileInputKey}
                                                        id="ikea-pricing-file-input"
                                                        type="file"
                                                        accept=".csv"
                                                        disabled={uploading}
                                                        onChange={this.handleFileChange}
                                                    />
                                                </FormGroup>
                                                <p className="text-muted" style={{ marginTop: "4px" }}>
                                                    Wymagany jest pojedynczy plik CSV z aktualnym nagłówkiem IKEA Pricing.
                                                </p>
                                                {
                                                    selectedFile && (
                                                        <p style={{ marginTop: "8px", marginBottom: 0 }}>
                                                            <i className="fa fa-file-text-o" /> {selectedFile.name}
                                                        </p>
                                                    )
                                                }
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <ControlLabel>Version label (opcjonalne)</ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        placeholder="np. 2026-04"
                                                        value={versionLabel}
                                                        disabled={uploading}
                                                        onChange={this.handleVersionLabelChange}
                                                    />
                                                </FormGroup>
                                                <FormGroup style={{ marginTop: "26px" }}>
                                                    <Button
                                                        type="submit"
                                                        disabled={uploading}
                                                        className="btn-fill btn-wd btn-icon btn btn-success"
                                                    >
                                                        <i className={uploading ? "fa fa-spinner fa-spin" : "fa fa-upload"} /> {uploading ? "Wgrywanie..." : "Wgraj i zaimportuj"}
                                                    </Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        {this.renderStatus()}
                                    </form>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default ExpertAdminImportIkeaPricing;
